import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { twJoin } from 'tailwind-merge'

import Button from '@/lib/components/designSystem/Button'
import GuardLoadingScreen from '@/lib/provider/GuardLoadingScreen'
import { useAuthConfiguration } from '@/lib/state/signInClients'
import { useIsWideLayout } from '@hooks/useMediaQuery.ts'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { isDevMode, isIntegrationMode } from '@utils/env'

import bgDesktop from './assets/signInBgDesktop.svg?no-inline'
import bgMobile from './assets/signInBgMobile.svg?no-inline'
import ubicaLogoWithText from './assets/ubicaLogoWText.svg?no-inline'

function SignInRoute(){
  const isWideLayout = useIsWideLayout()
  const { t } = useTypedTranslation()
  const { data, isLoading } = useAuthConfiguration()

  if (isLoading) return <GuardLoadingScreen i18nKey="common.loadingSignInClients" />

  const bgURL = isWideLayout ? bgDesktop : bgMobile

  return (
    <div
      className="flex h-screen flex-col items-center"
      style={{ background: `url(${bgURL}) no-repeat center/contain` }}
    >
      <div
        className={twJoin(`
          flex size-full max-w-102 flex-col items-center px-[.875rem] text-center font-medium text-primary
        `,
        isWideLayout && 'mt-28',
        !isWideLayout && 'mt-15 justify-between'
        )}
      >
        <div className='flex flex-col items-center'>
          <img src={ubicaLogoWithText} alt="ubica logo with text" className={twJoin('mb-10', isWideLayout ? 'h-21 w-55' : `
            h-[4.275rem] w-45
          `)} />
          <h1 className={twJoin('mb-3', isWideLayout ? 'text-3xl' : 'text-2xl')}>
            {t('signIn.title')}
          </h1>
          <p className='mb-12 max-w-95 text-sm text-secondary'>
            {t('signIn.description')}
          </p>
        </div>
        <div className='mb-15 w-full'>
          {
            data?.external && (
              <>
                <Button variant="outline" size='xl' aria-label={t('signIn.action') + ` ${data.external.name}`}
                  className="w-full"
                  iconLeading={<img src={data.external.logoUrl} className="
                    h-6 max-w-32 object-contain mix-blend-multiply
                  " alt="" />}
                  href={data.external.signInUrl}
                >
                  {t('signIn.action')} {data.external.name}
                </Button>

                <div className='my-4 h-4.5 w-full text-xs text-secondary'>
                  <span className='bg-white px-3 text-xs text-secondary'>{t('signIn.optionText')}</span>
                  <hr className='-mt-2 w-full border-t border-border-secondary'/>
                </div>
              </>
            )
          }

          {
            data?.internal && (
              <Button variant="outline" size='xl' aria-label={t('signIn.action') + ` ${data.internal.name}`}
                className="w-full"
                iconLeading={<img src={data.internal.logoUrl} className="h-6 max-w-32 object-contain mix-blend-multiply" alt="" />}
                href={data.internal.signInUrl}
              >
                {t('signIn.action')} {data.internal.name}
              </Button>
            )
          }
        </div>
      </div>
      {(isDevMode || isIntegrationMode) && <ReactQueryDevtools initialIsOpen={false} position="right" buttonPosition="bottom-right"/>}
    </div>
  )
}

export default SignInRoute